/**
 * Standard data structures and response types for platform metrics and telemetry.
 */

/**
 * Self-describing metric entry for automated admin discovery.
 */
export interface IMetricEntry {
  key: string;
  label: string;
  category: "business" | "storage" | "performance" | "system";
  value: number | string;
  unit?: string; // "count" | "bytes" | "ms" | "percent" | "bytes/day"
  description?: string;
}

/**
 * Storage and document statistics for a single Firestore collection/table.
 */
export interface IFirestoreTableSize {
  collectionName: string;
  docCount: number;
  sizeBytes: number;
  avgDocSizeBytes: number;
  totalSizeBytes?: number;
}

/**
 * Platform metrics summary snapshot persisted in Firestore and emitted to Cloud Logging.
 */
export interface IPlatformMetricsSummary {
  usersCount: number;
  activeUsersCount: number;
  memoriesCount: number;
  mediaCount: number;
  contactsCount: number;
  groupsCount: number;
  messagesCount: number;
  eventsCount: number;
  storageBytesUsed: number;
  storageMediaCount: number;
  estimatedGrowthRateBytesDaily: number;
  metricsRegistry?: Record<string, IMetricEntry>;
  firestoreTables?: Record<string, IFirestoreTableSize>;
  firestoreTotalSizeBytes?: number;
  firestoreTotalDocCount?: number;
  timestamp: number;
}

/**
 * Response returned by capturePlatformMetricsFunc.
 */
export interface ICapturePlatformMetricsResponse {
  status: boolean;
  timestamp: number;
  metrics?: IPlatformMetricsSummary;
  error?: string;
}

/**
 * Response returned by getPlatformMetricsFunc.
 */
export interface IGetPlatformMetricsResponse {
  status: boolean;
  timestamp: number;
  metrics?: IPlatformMetricsSummary;
  cached?: boolean;
  error?: string;
}
